<ng-container *transloco="let t;">
<div class="card">
    <div class="card-body p-0">
        <ul ngbNav #navWithIcons="ngbNav" class="nav-tabs border-bottom" (navChange)="changeSignatureTab($event)" [(activeId)]="signatureType">
            <li [ngbNavItem]="signatureTypeEnum.MYSIGNATURE">
                <a ngbNavLink><span [data-feather]="'edit-3'"></span> {{t("Side nav tab text (My signature - section) - My signature")}}</a>
                <ng-template ngbNavContent>
                    <h2 class="text-start font-medium-1 mb-2">{{t("Your signature text (My signature - section) - Here is your signature")}}</h2>
                    <div class="signatureMainContainer p-0">
                        <div class="signature-canvas-box">
                            <img #signature [src]="url_signature" alt="">
                        </div>

                        <button type="button" [disabled]="!url_signature" (click)="resetSignature()" class="btn float-end btn-primary mt-2" rippleEffect><span *ngIf="signatureloaders.my_signature" class="spinner-border spinner-border-sm me-1"></span> {{t("Reset signature text (My signature - section) - Reset signature")}}</button>
                    </div>

                </ng-template>
            </li>
            <li [ngbNavItem]="signatureTypeEnum.DRAW">
                <a ngbNavLink><span [data-feather]="'edit-3'"></span> {{t("Draw it navbar tab text (My signature - section) - Draw it")}}</a>
                <ng-template ngbNavContent>
                    <form (ngSubmit)="submitSignatureForm()">
                        <h2 class="text-start font-medium-1 mb-2">{{t("Draw your signature text (My signature - section) - Draw your signature")}}</h2>
                        <div class="signatureMainContainer p-0">
                            <div class="signature-canvas-box">
                                <div class="signature-color-picker">
                                    <div *ngFor="let color of penColors; let i = index" class="signature-color-{{color.colorname}}" [ngClass]="{'active-signature-color': i === penColorIndex}" (click)="changeColor(color,i)"></div>
                                </div>
                                <canvas id="regular_signaturepad" width="100%" height=270></canvas>
                                <span class="clear-signature" (click)="clearSignature()">{{t("Clear signature text (My signature - section) - Clear")}}</span>
                            </div>
                            <button type="submit" [disabled]="!signatureValue" class="btn float-end btn-primary mt-2" rippleEffect><span *ngIf="signatureloaders.draw" class="spinner-border spinner-border-sm me-1"></span> {{t("Apply signature text (My signature - section) - Apply")}}</button>
                        </div>
                    </form>
                </ng-template>
            </li>
            <li [ngbNavItem]="signatureTypeEnum.TYPE">
                <a ngbNavLink><span [data-feather]="'align-left'"></span> {{t("Type it navbar tav text (My signature - section) - Type it")}}</a>
                <ng-template ngbNavContent>
                    <form (ngSubmit)="submitSignatureForm()">
                        <h2 class="text-start font-medium-1 mb-2">{{t("Type your signature (My signature - section) - Type your signature")}}</h2>
                        <div class="signatureMainContainer signauter-type-box p-0">
                            <div class="signature-canvas-box">
                                <div class="signature-color-picker">
                                    <div *ngFor="let color of penColors; let i = index" class="signature-color-{{color.colorname}}" [ngClass]="{'active-signature-color': i === penColorIndex}" (click)="changeColor(color,i)"></div>
                                </div>
                                <input type="text" [style.color]="penColor" [(ngModel)]="signatureValue" [ngModelOptions]="{ standalone: true }" [style.fontFamily]="fontFamily" [placeholder]='t("Type your signature (My signature - section) - Type your signature")' class="signature-type-box" style="font-size: 34px;">
                            </div>
                            <canvas id="CustomSignCanvas" style="border:1px solid #d3d3d3; width: 100%;">Your mobile does not support the canvas element.</canvas>
                            <button type="submit" [disabled]="!signatureValue" class="btn float-end btn-primary mt-2" rippleEffect>
                                                        <span *ngIf="signatureloaders.type" class="spinner-border spinner-border-sm me-1"></span>
                                                        {{t("Apply signature text (My signature - section) - Apply")}}
                                                    </button>
                            <button type="button" (click)="changeNextFont()" class="btn float-end btn-success mt-2 me-50" rippleEffect>{{t("Next signature font (My signature - section) - Next font")}}</button>
                        </div>
                    </form>
                </ng-template>
            </li>
            <li [ngbNavItem]="signatureTypeEnum.UPLOAD">
                <a ngbNavLink><span [data-feather]="'upload'"></span> {{t("Upload navbar tab text (My signature - section) - Upload")}}</a>
                <ng-template ngbNavContent>
                    <form (ngSubmit)="submitSignatureForm()">
                        <h2 class="text-start font-medium-1 mb-2">{{t("Upload your signature text (My signature - section) - Upload your signature")}} </h2>
                        <div class="signatureMainContainer p-0">
                            <div *ngIf="!signatureBG" class="signature-canvas-box uplaodSignature-canvas-box">
                                <button type="button" (click)="uploadSignatureModalClick(uploadSignatureModal)" class="btn btn-success uploadSignatureBtn">{{t("Upload your signature text (My signature - section) - Upload your signature")}}</button>
                            </div>
                            <div *ngIf="signatureBG" class="signature-canvas-box uplaodSignature-canvas-box">
                                <img [src]="signatureBG" alt="Signature">
                            </div>
                            <button type="submit" [disabled]="!signatureValue" class="btn float-end btn-primary mt-2" rippleEffect><span *ngIf="signatureloaders.upload" class="spinner-border spinner-border-sm me-1"></span> {{t("Apply signature text (My signature - section) - Apply")}}
                                                </button>
                            <button type="button" *ngIf="signatureBG" (click)="removeSignatureImage()" class="btn float-end btn-danger mt-2 me-50" rippleEffect>{{t("Remove uploaded image text (My signature - section) - Remove Image")}}
                                                </button>
                        </div>
                    </form>
                </ng-template>
            </li>
            <li [ngbNavItem]="signatureTypeEnum.SMARTPHONE" *ngIf="false">
                <a ngbNavLink><span [data-feather]="'smartphone'"></span> {{t("Use smartphone navbar tab text (My signature - section) - Use smartphone")}}</a>
                <ng-template ngbNavContent>
                    <div class="useSmartphoneContentBody">
                        <h2 class="text-start font-medium-2 mb-2">TAKE A PHOTO OF YOUR SIGNATURE
                        </h2>
                        <p class="font-small-4 mb-1">Please follow the instruction below:</p>
                        <p class="font-small-4 mb-50">1. TAKE A PHOTO OF YOUR SIGNATURE</p>
                        <p class="font-small-4 mb-50">2. Email the signature to: import&#64;simplesign.io with the subject of: 27245731</p>
                        <p class="font-small-4 mb-50">2.1 For initials type subject: 27245438</p>
                        <p class="font-small-4 mb-50">3. Click continue</p>
                        <button type="submit" class="btn btn-primary mt-1" rippleEffect>Continue</button>
                    </div>

                </ng-template>
            </li>

        </ul>
        <div [ngbNavOutlet]="navWithIcons" class="mt-2"></div>
    </div>
</div>

<!-- upload signature Modal -->
<ng-template #uploadSignatureModal let-modal>
    <form (ngSubmit)="applyBgImage(); modal.dismiss('Cross click')">
        <div class="modal-header">
            <h4 class="modal-title" id="myModalLabel1">{{t("Upload signature modal title (My signature - section) - Upload signature")}}</h4>
            <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body p-2" tabindex="0" ngbAutofocus>
            <div *ngIf="!signatureImage" (click)="imageInput.click()" class="py-4 text-center m-auto font-medium-5 text-uppercase file-drop-zone col-md-6 col-lg-6 col-sm-12 upload-signature-uploadPopup-box">
            {{t("Click to upload signature modal text (My signature - section) - Click to upload signature")}}
            </div>
            <div *ngIf="signatureImage" class="py-1 border position-relative signature-imgae-upload-container text-end m-auto font-medium-5 text-uppercase col-md-10 col-lg-10 col-sm-12 upload-signature-cropped-box">
                <image-cropper
                    [imageChangedEvent]="imageChangedEvent"
                    [maintainAspectRatio]="false"
                    format="jpg"
                    output="base64"
                    [resizeToWidth]="256"
                    [cropperMinWidth]="128"
                    
                    (imageCropped)="imageCropped($event)"
                    (imageLoaded)="imageLoaded()"
                    (cropperReady)="cropperReady()"
                    (loadImageFailed)="loadImageFailed()"
                ></image-cropper>
                <div class="signature-btn-action">
                    <button type="button" (click)="removeSignatureImage()" placement="top" [autoClose]="true" triggers="hover" [ngbTooltip]='t("Delete button text (delete button) - delete")' class="btn btn-icon btn-warning signature-delete-btn waves-effect waves-float waves-light">
                        <i data-feather="trash-2" class="cursor-pointer lighten-2"></i>
                    </button>
                </div>
            </div>
        </div>
        <input type="file" (change)="getSignatureImage($event)" hidden #imageInput>
        <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" (click)="removeSignatureImage();modal.dismiss('Cross click')" rippleEffect>
                {{t("Cancel button text (cancel button) - cancel")}}
            </button>
            <button type="submit" class="btn btn-success" rippleEffect>
                {{t("Crop upload image (My signature - section) - Crop")}}
            </button>
        </div>
    </form>
</ng-template>
<!-- / upload signature Modal -->
</ng-container>